import React from 'react';
import { Group, Card, Text, Stack, Box } from '@mantine/core';
import { TrendingUp, Clock, AlertTriangle, DollarSign } from 'lucide-react';
import { Loan } from '../types/loan';
import { RuleViolation } from '../types/rule';
interface MetricsPanelProps {
  loans: Record<string, Loan[]>;
  violations: RuleViolation[];
}
export function MetricsPanel({
  loans,
  violations
}: MetricsPanelProps) {
  const allLoans = Object.values(loans).flat();
  const totalVolume = allLoans.reduce((sum, loan) => sum + loan.amount, 0);
  const avgDaysInStage = allLoans.length > 0 ? Math.round(allLoans.reduce((sum, loan) => sum + loan.daysInStage, 0) / allLoans.length) : 0;
  const criticalAlerts = violations.filter(v => v.severity === 'critical').reduce((sum, v) => sum + v.affectedLoanIds.length, 0);
  const urgentLoans = allLoans.filter(loan => loan.isUrgent).length;
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 0
    }).format(amount);
  };
  const metrics = [{
    icon: DollarSign,
    label: 'TOTAL PIPELINE VOLUME',
    value: formatCurrency(totalVolume),
    subValue: `${allLoans.length} active loans`,
    valueColor: '#4ade80',
    iconBgColor: 'rgba(34, 197, 94, 0.15)',
    iconColor: '#22c55e'
  }, {
    icon: Clock,
    label: 'AVG DAYS IN STAGE',
    value: avgDaysInStage,
    subValue: 'across all stages',
    valueColor: avgDaysInStage > 5 ? '#fb923c' : '#4ade80',
    iconBgColor: avgDaysInStage > 5 ? 'rgba(249, 115, 22, 0.15)' : 'rgba(34, 197, 94, 0.15)',
    iconColor: avgDaysInStage > 5 ? '#f97316' : '#22c55e'
  }, {
    icon: AlertTriangle,
    label: 'CRITICAL ALERTS',
    value: criticalAlerts,
    subValue: `${violations.length} rules violated`,
    valueColor: '#f87171',
    iconBgColor: 'rgba(239, 68, 68, 0.15)',
    iconColor: '#ef4444'
  }, {
    icon: TrendingUp,
    label: 'URGENT PRIORITY',
    value: urgentLoans,
    subValue: 'require immediate attention',
    valueColor: urgentLoans > 0 ? '#f87171' : 'rgba(255, 255, 255, 0.5)',
    iconBgColor: urgentLoans > 0 ? 'rgba(239, 68, 68, 0.15)' : 'rgba(255, 255, 255, 0.08)',
    iconColor: urgentLoans > 0 ? '#ef4444' : 'rgba(255, 255, 255, 0.4)'
  }];
  return <Group gap="md" grow data-id="element-350">
      {metrics.map((metric, index) => {
      const Icon = metric.icon;
      return <Card key={index} padding="lg" radius="md" withBorder={false} style={{
        backgroundColor: 'rgba(255, 255, 255, 0.06)',
        border: '1px solid rgba(255, 255, 255, 0.08)',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)'
      }} data-id="element-351">
            <Stack gap="xs" data-id="element-352">
              <Group justify="space-between" align="flex-start" data-id="element-353">
                <Box style={{
              padding: '10px',
              borderRadius: '8px',
              backgroundColor: metric.iconBgColor
            }} data-id="element-354">
                  <Icon size={20} color={metric.iconColor} data-id="element-355" />
                </Box>
              </Group>
              <Stack gap={4} data-id="element-356">
                <Text size="xl" fw={800} style={{
              color: metric.valueColor,
              fontSize: '1.75rem'
            }} data-id="element-357">
                  {metric.value}
                </Text>
                <Text size="xs" fw={700} tt="uppercase" style={{
              letterSpacing: '0.05em',
              color: 'rgba(255, 255, 255, 0.5)'
            }} data-id="element-358">
                  {metric.label}
                </Text>
                <Text size="xs" style={{
              color: 'rgba(255, 255, 255, 0.35)'
            }} data-id="element-359">
                  {metric.subValue}
                </Text>
              </Stack>
            </Stack>
          </Card>;
    })}
    </Group>;
}